import {Button} from '@startlibs/components';
import {getColor} from '@startlibs/utils';
import styled from 'styled-components';

export const AddButton = styled(Button).attrs({icon:'plus-circle',color:'gray240'})`
  width: 100%;
  color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 0 1px ${getColor('gray210')};
`
